<div class="search-wrapper">
  <custom-input
    [type]="'text'"
    [name]="'search'"
    label="Search"
    [(ngModel)]="search"
    (ngModelChange)="updateSearch()"
  />
</div>
